export class StorefrontApiValidationError extends Error {
   constructor(readonly failedValidations: string[] = []) {
      super(StorefrontApiValidationError.ErrorMsg);
   }

   static get ErrorMsg(): string {
      return 'There were validation error(s) returned from a Shopify Storefront API request';
   }
}
